export enum TaskPermissions {
  VIEW = 'VIEW_TASKS',
}
